const getClickableLink = (link: string | undefined) => {
  if (link !== undefined)
    return link.startsWith("http://") || link.startsWith("https://")
      ? link
      : `//${link}`;
  else return;
};

export default getClickableLink;
